//get the API for the model
import { getApi } from "aldoo-ra/CMS/field-api-resolver"

export default {
  type: "DatabaseModel",
  preFormat: async (fieldValues, Type) => {
    if (!fieldValues) return fieldValues
    // If Type is not provided or has no fields, return as-is
    if (!Type || !Type.fields) return fieldValues
    //the incoming fieldValues from the server is the _id
    //we need to get the object behind this _id

    //each item has the following fields
    const fieldTypes = Type.fields
    for (const field of fieldTypes) {
      if (!field) continue

      // Handle both string type and object type {value: "DatabaseModel", name: "DatabaseModel"}
      const fieldType = typeof field.type === "object" && field.type?.value
        ? field.type.value
        : field.type

      if (fieldType !== "DatabaseModel") continue
      if (!fieldValues[field.id]) continue

      const itemValue = fieldValues[field.id]

      //if the itemValue has an _id, we don't need to fetch it
      if (itemValue._id) continue

      //model - the name of the mongoose model
      //item - the _id of the item

      // Handle different formats of itemValue:
      // 1. Direct ObjectId string (legacy format)
      // 2. {model: "ModelName", item: "objectId"} (current saved format)
      let model, item
      
      if (typeof itemValue === 'string') {
        // Legacy format: itemValue is direct ObjectId, model comes from field.item
        model = field.item
        item = itemValue
      } else if (itemValue && typeof itemValue === 'object' && itemValue.model && itemValue.item) {
        // Current saved format: {model: "ModelName", item: "objectId"}
        model = itemValue.model
        item = itemValue.item
      } else {
        // Unknown format, use field.item as fallback
        model = field.item
        item = itemValue
      }
      
      // Check if API exists and has Get method
      const ModelAPI = getApi(model)
      if (!ModelAPI || typeof ModelAPI.Get !== 'function') {
        console.warn(`API or Get method not found for model: ${model}`, {
          fieldId: field.id,
          itemValue,
          ModelAPI
        })
        fieldValues[field.id] = null
        continue
      }
      
      const { Get } = ModelAPI
      let response = await Get({ match: { _id: item } })
      //set the response
      fieldValues[field.id] = response && response.length ? response[0] : null
    }

    return fieldValues
  },
  postFormat: (fieldValues, Type) => {
    if (!fieldValues) return fieldValues
    // If Type is not provided or has no fields, return as-is
    if (!Type || !Type.fields) return fieldValues

    //each item has the following fields
    const fieldTypes = Type.fields
    for (const field of fieldTypes) {
      if (!field) continue

      // Handle both string type and object type {value: "DatabaseModel", name: "DatabaseModel"}
      const fieldType = typeof field.type === "object" && field.type?.value
        ? field.type.value
        : field.type

      if (fieldType !== "DatabaseModel") continue

      const itemValue = fieldValues[field.id]

      // Handle null values - save them as null
      if (!itemValue) {
        fieldValues[field.id] = null
        continue
      }

      // Skip if value is already in the correct format: {model: "...", item: "..."}
      if (itemValue && typeof itemValue === 'object' && itemValue.model && itemValue.item) {
        continue
      }

      // Skip if value is just a string (ObjectId)
      if (typeof itemValue === "string") {
        continue
      }

      // If we reach here, we need to format the value
      // Extract _id from potentially nested object structure
      let actualId = itemValue._id

      // Recursively unwrap nested _id objects if corrupted
      while (actualId && typeof actualId === 'object' && actualId._id) {
        actualId = actualId._id
      }

      if (!actualId) {
        console.warn(`DatabaseModel field ${field.id} has no valid _id`, itemValue)
        fieldValues[field.id] = null
        continue
      }

      const model =
        typeof field.item === "string" ? field.item : field.item.type

      const formatted = {
        model, //this is the model name
        item: actualId,
      }

      //when we post format this field, we need to store just the id over the database
      fieldValues[field.id] = formatted
    }

    return fieldValues
  },
}
